__webpack_require__.p = "/prototype/cb-payments/dashboard/";